// extracted by mini-css-extract-plugin
export var numpadContainer = "_k9-1";
export var phoneButton = "_k9-0";